import { createSelector } from '@reduxjs/toolkit';
import { selectAllMembers } from '@/features/members/membersSlice';

export const selectParticipantsForFilter = createSelector([selectAllMembers], (members) =>
    (members ?? [])
        .map((m: any) => ({
            // берём _id, иначе id, иначе pathname — всё приводим к строке
            value: String(m._id ?? m.id ?? m.pathname ?? ''),
            label: m.name ?? [m.first_name, m.last_name].filter(Boolean).join(' ') ?? 'Unknown',
        }))
        .filter((x) => x.value) // на всякий случай
        .sort((a, b) => a.label.localeCompare(b.label))
);
